@import "../../../../../shared/scss";

:host {
  display: block;
  inline-size: 100%;
  margin-inline: 0px;
  padding-inline: 0px;
  border: none;
}

.model-area-button {
  @include pds-focus("none");
  @include pds-hover;

  &.banner {
    background-size: auto 100%;
    background-position: center;
    background-repeat: no-repeat;
    aspect-ratio: 16/7;
    transition: $pds-motion-duration-short $pds-motion-easing-base;
    position: relative;

    &:hover {
      background-size: auto 110%;
    }

    .gradient-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 40%;
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 1) 0%,
        transparent 100%
      );
      pointer-events: none;
      border-radius: p-px-to-rem(8px) p-px-to-rem(8px) 0 0;
    }
  }

  background-color: $pds-theme-light-background-surface;
  border-radius: p-px-to-rem(8px);
  cursor: pointer;
  padding-block: $pds-spacing-static-medium + $pds-spacing-static-x-small;
  padding-inline: $pds-spacing-static-medium + $pds-spacing-static-x-small;
  margin-block: 0;
  margin-inline: 0;

  @media (hover: hover) {
    &:hover,
    &:focus,
    &:active {
      img.model-image {
        @include model-hover-animation-transform();
      }

      @include pds-media-query-min("s") {
        background-color: $pds-theme-light-background-base;
      }
    }
  }

  &.banner {
    .model-content {
      block-size: 100%;
      justify-content: space-between;
      position: relative;
    }
  }

  .model-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .model-image-container {
      position: relative;
      overflow: hidden;
      inline-size: 100%;

      display: block;
      box-sizing: border-box;
      margin-block-start: $pds-spacing-static-x-small;

      &-ratio-content {
        position: absolute;
        inset-block-start: 0;
        inset-inline-start: 0;
        block-size: 100%;
        overflow: hidden;

        display: flex;
        justify-content: center;
        align-items: center;

        // We always want to have padding right, because the animation always translates to the right (ltr & rtl)
        padding-right: $model-hover-animation-translate-space;
        inline-size: calc(100% - ($model-hover-animation-translate-space));
      }

      .model-image {
        position: relative;
        backface-visibility: hidden;
        object-fit: cover;
        inline-size: 100%;
        block-size: auto;
        @include model-hover-animation-transition();
      }
    }

    .model-tags {
      display: block;
      margin-block-start: $pds-spacing-static-small;

      phn-model-tags {
        display: block;
        block-size: 30px;
      }
    }
  }
}
